export default "__VITE_ASSET__CYpFQQHZ__"